const API_BASE_URL = process.env.REACT_APP_API_URLPATH;
const WEB_BASE_URL = process.env.REACT_APP_WEB_URLPATH;

const getProductGuide = (url) => {
  return http(url, {
    headers: {
      Accept: "application/json",
    },
  });
};

// Future get for accessing information from episerver
const getWeb = (url) => {
    return httpWeb("/api/productguideweb/" + url);
};

const getWebText = (url) => {
  return httpWebText("/api/productguideweb/" + url);
};

const getPdb = (url) => {
    return httpWeb("/api/productguidepdb/" + url);
};

const getImages = (url) => {
  return fetch(API_BASE_URL + "/api/productguidepdb/" + url)
    .then((result) => result.blob())
    .then(
      (result) => {
        return result;
      },
      (error) => {
        console.log("Error: ", error);
        return error;
      }
    );
};

const postPdb = (url, body) => {
  return httpWeb("/api/productguidepdb/" + url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body), // body data type must match "Content-Type" header
  });
};

const postWeb = (url, body) => {
    return httpWeb("/api/productguideweb/" + url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body), // body data type must match "Content-Type" header
  });
};

const http = (url, object) => {
  return fetch(API_BASE_URL + url, object)
    .then((result) => result.json())
    .then(
      (result) => {
        return result;
      },
      (error) => {
        console.log("Error: ", error);
        return error;
      }
    );
};

const httpWeb = (url, object) => {
    return fetch(WEB_BASE_URL + url, object)
        .then((result) => result.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                console.log("Error: ", error);
                return error;
            }
        );
};

const httpWebText = (url, object) => {
  return fetch(WEB_BASE_URL + url, object)
      .then((result) => result.text())
      .then(
          (result) => {
              return result;
          },
          (error) => {
              console.log("Error: ", error);
              return error;
          }
      );
};


export { getPdb, postPdb, getWeb, postWeb, getProductGuide, getImages, getWebText };
